var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"hidden-print-only",staticStyle:{"z-index":"0"},attrs:{"padless":"","absolute":""}},[_c('v-col',{staticClass:"text-right md-font",attrs:{"cols":"12"}},[_vm._v(" Version 1.0.1 | Copyright © "+_vm._s(new Date().getFullYear())+" | "),_c('a',{attrs:{"href":"http://64vision.com","target":"_blank"}},[_vm._v("64VISION")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }